import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import QueryString from 'query-string';
import Footer from 'app/layout/footer/Footer';
import FooterMobile from 'app/layout/footer/FooterMobile';
import { Spinner, Button } from 'react-bootstrap';
import SellingStores from 'app/layout/offer/SellingStores';
import CustomScroller from 'app/components/common/CustomScroller';
import BreadCrumbs from 'app/components/common/bread-crumbs';
import {
  getSEOFriendlyURL, getSeoShopUrl, getSeoTitle, LOVELOCAL,
} from 'app/utilities/Utils';
import RoundedCartCounter from 'app/components/derived/cart/RoundedCartCounter';
import DefaultGuestLocationAlert from 'app/components/common/DefaultGuestLocationAlert';
import { CustomModal, Placeholder } from 'app/components/common';
import {
  gaLogAddOrRemoveProductFromCart, gaLogPageView, gaLogProductDetails,
} from 'ecommerce_ga_events/EcommerceGAEvents';
import { fbLogViewContent } from 'facebook/Facebook';
import { Link } from 'react-router-dom';
import { recommendedProducts } from 'api/api';
import ProductThumb from 'app/components/common/ProductThumb';
import style from './index.module.scss';

import {
  productDetailsApi,
  exploreShopsApi,
  // relatedProductApi,
  // alsoBoughtApi,
  getCatApi,
  getNearbySToreApi,
  getRelatedOffersApi,
  comboOfferDetailApi,
} from './api';
import ProductImageCarousal from './layout/product-image-carousal';
import ProductDetails from './layout/product-details';
import ExploreCard from './layout/explore-card';
// import SimilarProducts from './layout/similar-products';
import RelatedOffers from './layout/related-offers';
import * as LogClevertapEvent from '../../../clevertap/LogEvent';

const ProductScreen = (props:any) => {
  const {
    isMobile, language, cartItems, toggleSideOverlay, history,
    location, match, selectedAddress, cartId,
  } = props;

  const baseUrl = window.location.origin;

  const [productId, setProductId] = useState(0);
  const [breadCrumbUrl, setBreadCrumbsUrl] = useState<any>();
  const initialQuantity = 0;

  const showOfferDetail = location?.state?.showOfferDetail || false;
  const [storeId, setStoreId] = useState(location?.state?.sid
    || (QueryString.parse(location?.search).sid || ''));

  const [storeName, setStoreName] = useState(location?.state?.storeName || '');
  const [itemQuantity, setItemQuantity] = useState(initialQuantity);

  // const [results, setResults] = useState(null);

  const [productState, setProductState] = useState<any>({
    product: null,
    proLoading: true,
    variants: null,
    selectedVariant: null,
    showStoreVariants: false,
    addVariant: false,
    proError: false,
    data: null,
  });

  const [shopState, setShopState] = useState<any>({
    shops: null,
    shopLoading: true,
    shopError: false,
  });

  // const [frequentState, setFrequentState] = useState<any>({
  //   frequent: null,
  //   frequentLoading: true,
  //   frequentError: false,
  // });

  const [relatedState, setRelatedState] = useState<any>({
    relatedProducts: null,
    relatedLoading: true,
    relatedError: false,
  });

  const [childCatSeo, setChildCatSeo] = useState<any>({
    childCat: null,
    parent: null,
    childCatErr: false,
  });

  const [moreShops, setMoreShops] = useState<any>({
    city: null,
    storeCategories: null,
    localities: null,
  });

  const [relatedOffers, setRelatedOffers] = useState<any>({
    relatedOffers: null,
    relatedOffersLoading: false,
    relatedOffersError: false,
  });

  const latLng = selectedAddress
    ? `${selectedAddress.location.lat},${selectedAddress.location.lng}`
    : '19.1207983,72.8782323';

  useEffect(() => {
    setProductState({
      ...productState,
      proLoading: true,
    });
    gaLogPageView();
    let fetchProductId = null;

    if (location.pathname === '/product-details') {
      fetchProductId = Number(QueryString.parse(location.search).productId);
    } else {
      // extracting query params
      const productDetails = match.params.productDetails.split('?');
      const parts = productDetails[0].split('-');
      fetchProductId = Number(parts[parts.length - 1]);
    }
    if (fetchProductId) {
      setProductId(fetchProductId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  /// /// Get shops api call /// ///
  const getShops = (selVariant: { productId: any; }) => {
    let shopData = null;
    exploreShopsApi(
      'get',
      null,
      latLng,
      showOfferDetail ? selVariant.productId : productId,
    )
      .then((res:any) => {
        shopData = res.data.results;

        setShopState({
          ...shopState,
          shops: shopData,
          shopLoading: false,
        });
      })
      .catch(() => {
        setShopState({
          ...shopState,
          shopLoading: false,
          shopError: true,
        });
      });
  };
  /// /// Get also Bought api call /// ///
  // const getFrequentlyBought = () => {
  //   let alsoBoughtData = null;
  //   alsoBoughtApi('get', null, latLng, productId)
  //     .then((res:any) => {
  //       alsoBoughtData = res.data.results;

  //       setFrequentState({
  //         ...frequentState,
  //         frequent: alsoBoughtData,
  //         frequentLoading: false,
  //       });
  //     })
  //     .catch(() => {
  //       setFrequentState({
  //         ...frequentState,
  //         frequentError: true,
  //         frequentLoading: false,
  //       });
  //     });
  // };

  /// /// Get related product api call /// ///
  const getRelatedProduct = (retailerProductId : any) => {
    let relatedData = null;
    // relatedProductApi(
    //   'get',
    //   null,
    //   {
    //     location: latLng,
    //     storeCode: storeId,
    //   },
    //   showOfferDetail ? selVariant.productId : productId,
    // )
    recommendedProducts(
      'PRODUCTDETAILS',
      retailerProductId,
      '',
    )
      .then((res:any) => {
        relatedData = res.data.data;

        setRelatedState({
          ...relatedState,
          relatedProducts: relatedData,
          relatedLoading: false,
        });
      })
      .catch(() => {
        setRelatedState({
          ...relatedState,
          relatedLoading: false,
          relatedError: true,
        });
      });
  };

  /// /// Get related offers api call ///  ///
  const getRelatedOffers = () => {
    let relatedData = null;
    getRelatedOffersApi(
      'get',
      null,
      {
        location: latLng,
        excludeOfferId: productId,
        storeId,
        offerType: 'SPECIAL_BOGO_OFFER',
      },
    ).then((res:any) => {
      relatedData = res.data.results;
      setRelatedOffers({
        ...relatedOffers,
        relatedOffers: relatedData,
        relatedOffersLoading: false,
      });
    })
      .catch(() => {
        setRelatedOffers({
          ...relatedOffers,
          relatedOffersLoading: false,
          relatedOffersError: true,
        });
      });
  };

  /// /// Get seo interlinks //////
  const getChildCategory = () => {
    getCatApi('get', null, latLng, productId)
      .then((res:any) => {
        setChildCatSeo({
          ...childCatSeo,
          childCat: res.data.childs,
          parent: res.data.parent,
          childCatErr: false,
        });
      })
      .catch(() => {
        setChildCatSeo({
          ...childCatSeo,
          childCat: null,
          parent: null,
          childCatErr: false,
        });
      });
  };

  const getNearbyStore = () => {
    getNearbySToreApi('get', null, latLng)
      .then((res:any) => {
        setMoreShops({
          ...moreShops,
          city: res.data.city,
          storeCategories: res.data.storeCategories,
          localities: res.data.localities,
          moreShopsErr: false,
        });
      })
      .catch(() => {
        setMoreShops({
          ...moreShops,
          city: null,
          storeCategories: null,
          localities: null,
          moreShopsErr: true,
        });
      });
  };

  const loadProductData = () => {
    let proData:any = null;
    let selectVar = 0;
    setProductState({
      ...productState,
      proLoading: true,
      proError: false,
    });
    (showOfferDetail
      ? comboOfferDetailApi('get', null, productId, cartId)
      : productDetailsApi('get', null, selectedAddress.location.lat || '19.1207983',
        selectedAddress.location.lng || '72.8782323', productId, storeId))
      .then((res:any) => {
        proData = res.data.data;
        if (cartItems) {
          const selectCartItem = Object.keys(cartItems);
          selectCartItem.forEach((item: any) => {
            let itemFound;
            if (proData.variants) {
              itemFound = proData.variants.findIndex(
                (el:any) => el.retailerProductId === cartItems[item].productId,
              );
            } else {
              itemFound = proData.productsWithMeasurements.findIndex(
                (el:any) => el.retailerProductId === cartItems[item].productId,
              );
            }
            if (itemFound >= 0) {
              selectVar = itemFound;
            }
          });
        }
        setProductState({
          ...productState,
          product: proData.variants ? proData : proData.productsWithMeasurements[0],
          proLoading: false,
          variants: proData.productsWithMeasurements,
          selectedVariant: proData.variants
            ? proData.variants[selectVar]
            : proData.productsWithMeasurements[selectVar],
          data: proData,
        });
        setStoreId(proData.variants ? (proData.storeId) : (proData.store_id));
        let allVariantsForViewContent;
        if (proData.variants) {
          allVariantsForViewContent = proData.variants.map((p: any) => ({
            item_id: p.productId,
            item_name: p.name,
            price: p.sellingPrice,
            quantity: 10,
          }));
        } else {
          allVariantsForViewContent = proData.productsWithMeasurements.map((p: any) => ({
            item_id: p.libraryProductId,
            item_name: p.name,
            price: p.sellingPrice,
            quantity: 10,
          }));
        }
        fbLogViewContent([productId]);
        gaLogProductDetails(
          proData.variants
            ? proData.variants[selectVar].sellingPrice
            : proData.productsWithMeasurements[selectVar].sellingPrice,
          allVariantsForViewContent,
        );
        getShops(proData.variants
          ? proData.variants[selectVar]
          : proData.productsWithMeasurements[selectVar]);
        // getFrequentlyBought();
        getRelatedProduct(proData.retailerProductId);
        getRelatedOffers();
        getChildCategory();
        getNearbyStore();
      })
      .catch(() => {
        setProductState({
          ...productState,
          proLoading: false,
          proError: true,
        });
      });
  };

  useEffect(() => {
    if (productId > 0) {
      loadProductData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId]);

  const {
    product, proLoading, variants, selectedVariant, showStoreVariants,
    proError, data,
  } = productState;

  const {
    shops, shopLoading,
  } = shopState;
  // const {
  //   frequent, frequentLoading,
  // } = frequentState;
  const {
    relatedProducts, relatedLoading,
  } = relatedState;
  const {
    relatedOffers: offers, relatedOffersLoading,
  } = relatedOffers;
  const activeVariants = (variants || []).filter((i: any) => i.inStock);

  const addProductHandler = () => {
    if (isMobile && selectedVariant) {
      toggleSideOverlay(() => (
        <SellingStores
          productId={selectedVariant.productId}
          language={language}
          isMobile={isMobile}
          onClose={() => {
            toggleSideOverlay(null);
          }}
          isProductDetailScreen
        />
      ));
    } else {
      setProductState({
        ...productState,
        showStoreVariants: true,
      });
    }
  };

  useEffect(() => {
    setItemQuantity(0);
    let checkCondition = null;
    if (cartItems && selectedVariant) {
      const cartItem = Object.keys(cartItems);

      cartItem.forEach((item: any) => {
        if (data.productsWithMeasurements?.length > 1) {
          checkCondition = Number(selectedVariant.retailerProductId);
        } else {
          checkCondition = Number(selectedVariant.retailerProductId) || Number(productId);
        }
        if (checkCondition === Number(cartItems[item].productId)
        ) {
          setItemQuantity(cartItems[item].quantity);
          setStoreName(cartItems[item]?.productInfo?.storeName || '');
          setStoreId(cartItems[item].storeId);
        }
      });
    } else {
      setItemQuantity(0);
    }
  }, [cartItems, selectedVariant, product, productId]);

  const pageMeta = (
    <Helmet>
      <title>
        {`Buy ${product ? `${product.name} ` : 'products '} online from shops near you | LoveLocal`}
      </title>
      <meta
        name="description"
        content={`Buy ${product ? `${product.name} ` : ''} online from shops on LoveLocal. Use various payment modes, avail great discounts and home delivery when you shop from nearby stores. Try LoveLocal today.`}
      />
      <link
        rel="canonical"
        href={`https://${window.location.host}${window.location.pathname}`}
      />

      {product
      && (
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org/",
            "@type": "Product",
            "name": "${product.name}",
            "image": "${product.images ? product.images[0] : product.imageUrls[0]}",
            "description": "${product.description}",
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.4",
              "reviewCount": "89"
            }
          }
        `}
      </script>
      )}
    </Helmet>
  );

  const goToShopDetail = () => {
    history.push({
      pathname: `/shops/${product.store.id}`,
    });
  };

  useEffect(() => {
    if (product) {
      const breadUrl:any = [];
      data.category.map((item:any, index:number) => {
        let seoUrl = getSEOFriendlyURL(item);
        const seoTitle = getSeoTitle(seoUrl);
        if (seoUrl === 'all') {
          seoUrl = 'pc';
        }

        return (
          breadUrl.push({ id: index, name: seoTitle, url: seoUrl })
        );
      });
      setBreadCrumbsUrl(breadUrl);
    }
  }, [product]);

  const { shopUrl, hasSeoData } = getSeoShopUrl(
    data?.country || 'India',
    data?.city || '',
    data?.locality || '',
    data?.storeTypeName || '',
    data?.storeName || '',
    data?.store_id || '',
  );
  
  return (
    <>
      {pageMeta}
      <DefaultGuestLocationAlert
        {...props}
      />
      {proLoading
      && (
        <div className={style.loading}>
          <Spinner
            animation="border"
            variant="primary"
          />
        </div>
      )}

      {
        proError && (
          <div
            className="h-100 d-flex justify-content-center align-items-center"
          >
            <Placeholder
              language={language}
              handleRetry={loadProductData}
              imageSrc="/images/error-placeholder.png"
              heading="Oh no! Something broke"
            />
          </div>
        )
      }

      {(product && !proLoading && !proError) && (
      <div className={` ${style.productMain}`}>

        <div className={style.breadCrumbsOuter}>
          <BreadCrumbs breadCrumbs={breadCrumbUrl} />
        </div>
        <div className={style.productHeadBack} />

        <div className={`${style.productContainer}`}>

          {/* {product.name} */}
          <div className={style.contentContainer}>
            <div className={style.imageContainer}>
              <ProductImageCarousal
                images={product.images ? product.images : product.imageUrls}
                imageAlt={product.name}
                showOfferDetail={showOfferDetail}
                selectedVariant={selectedVariant}
              />
            </div>

            {/* Product name container */}
            <div className={style.nameContainer}>
              {
                hasSeoData
                  ? (
                    <Link
                      to={shopUrl}
                      className={style.shopName}
                    >
                      {product.store ? product.store.name : product.storeName }
                    </Link>
                  )
                  : (
                    <button
                      type="button"
                      className={style.shopName}
                      onClick={goToShopDetail}
                    >
                      {product.store ? product.store.name : product.storeName}
                    </button>
                  )
              }
              {(
                <h1 className={style.productName}>
                  {selectedVariant.name
                    ? selectedVariant.name
                    : product.name}
                </h1>
              )}
              {selectedVariant.mrp && (
                <div className={style.mrp}>
                  <span>Product MRP:</span>
                  <span
                    className={
                      (selectedVariant.sellingPrice
                        && selectedVariant.sellingPrice < selectedVariant.mrp)
                        ? style.mrpSpanStrike
                        : ''
                    }
                  >
                    &#8377;
                    {' '}
                    {`${selectedVariant.mrp}`}
                  </span>
                </div>
              )}

              {(selectedVariant.sellingPrice
              && selectedVariant.sellingPrice !== selectedVariant.mrp)
                && (
                <div className={style.sellingPrice}>
                  <span>Selling Price:</span>
                  <span className={style.sellingPriceSpan}>
                    &#8377;
                    {' '}
                    {`${selectedVariant.sellingPrice}`}
                  </span>
                  {selectedVariant.displayTag !== ''
                    && <span className={style.displayTag}>{selectedVariant.displayTag}</span>}
                </div>
                )}

              {activeVariants && activeVariants.length > 0
              && (
              <div className={style.availableContainer}>
                <div className={style.availableLabel}>Available in:</div>
                <div className={style.availableIn}>
                  {activeVariants.map((item:any, index:number) => (
                    <span
                      key={item.libraryProductId}
                      onClick={() => setProductState({
                        ...productState,
                        selectedVariant: activeVariants[index],
                      })}
                      onKeyUp={() => setProductState({
                        ...productState,
                        selectedVariant: activeVariants[index],
                      })}
                      role="button"
                      tabIndex={0}
                      className={
                        item.libraryProductId === selectedVariant.libraryProductId
                          ? style.activeVariant : ''
                      }
                    >
                      {item.measurementDisplayText}
                    </span>
                  ))}
                </div>

              </div>
              )}
              <div className={`${style.addButton}`} style={{ paddingLeft: '0px', paddingRight: '0px' }}>
                {storeId
                  ? (
                    <RoundedCartCounter
                      language={language}
                      productInfo={{
                        storeName,
                        productName: product.name,
                        sellingPrice: selectedVariant.sellingPrice,
                        mrp: selectedVariant.mrp,
                        imageUrl: product.image || LOVELOCAL.productPlaceholder,
                        measurementDisplayText: selectedVariant.unitString,
                      }}
                      isPrimaryBackground
                      storeCode={storeId}
                      productId={selectedVariant.retailerProductId}
                      quantity={itemQuantity}
                      onSuccess={(productCount:any, isAdding:any) => {
                        LogClevertapEvent.skusUpdatedToCart(
                          storeName,
                          product.name,
                          productCount,
                        );
                        gaLogAddOrRemoveProductFromCart(
                          isAdding,
                          selectedVariant.sellingPrice,
                          {
                            item_id: productId,
                            item_name: product.name,
                            price: selectedVariant.sellingPrice,
                            quantity: productCount,
                          },
                        );
                      }}
                    />
                  )
                  : (
                    <>
                      <Button
                        variant="outline-primary"
                        className={`fs-5 py-1 cart-counter-min border-radius-8 w-100 fs-6 ${activeVariants.length === 0 ? 'bg-gray' : ''}`}
                        onClick={addProductHandler}
                        disabled={activeVariants.length === 0}
                      >
                        ADD
                      </Button>
                      {
                        activeVariants.length === 0 && (
                          <div className="mt-3 text-medium fs-6">
                            *This Product is not available in stock
                          </div>
                        )
                      }
                    </>
                  )}
              </div>
            </div>

            {/* Product Details */}
            {
              (
                product.description
                || product.ingredients
                || product.moreInfo
                || product.nutitionalFacts
                || product.otherProductInfo
              ) && <ProductDetails details={product} />
            }

            {/* Explore shop */}
            {(shops && !shopLoading)
            && (
              (shops.length > 0)
            && (
            <div className={style.exploreContainer}>
              <div className={style.headText}>Explore shop with this product</div>
              <div className={style.scrollOuter}>
                <CustomScroller
                  content={(
                    <div className="d-flex">
                      <>
                        {shops.map((item:any) => (
                          <div className={style.exploreShopCard} key={item.code}>
                            <ExploreCard
                              image={item.shopImage}
                              title={item.displayName}
                              type={item.shopType}
                              rating={Math.round(item.rating * 10) / 10}
                              deliveryTime={item.deliveryTime}
                              deliveryDistance={item.distance}
                              item={item}
                              history={history}
                            />
                          </div>
                        ))}
                      </>
                    </div>
                )}
                  contentPrefix="productShop"
                />
              </div>

            </div>
            )
            )}

            {/* Frequently bought together */}
            {/* {(storeId && frequent && frequentLoading)
            && (
              (frequent.length > 0)
              && (
              <div className={style.similarProContainer}>
                <div className={style.headText}>Frequently Bought Together</div>

                <div className={style.scrollOuter}>

                  <CustomScroller
                    content={(
                      <div className="d-flex">
                        <>
                          {frequent.map((item:any) => (
                            <div className={style.exploreCard} key={item.id}>
                              <SimilarProducts
                                productId={item.retailerProductId}
                                item={item}
                                cartItems={cartItems}
                                history={history}
                                language={language}
                              />
                            </div>
                          ))}
                        </>
                      </div>
                )}
                    contentPrefix="frequentlyBought"
                  />
                </div>
              </div>
              )
            )} */}

            {/* Offers on this product */}
            {(storeId && offers && !relatedOffersLoading)
            && (
              (offers.length > 0)
              && (
              <div className={style.similarProContainer}>
                <div className={style.headText}>Offers on this product</div>

                <div className={style.scrollOuter}>

                  <CustomScroller
                    content={(
                      <div className="d-flex">
                        <>
                          {offers.map((item:any) => (
                            <div className={style.exploreCard} key={item.id}>
                              <RelatedOffers
                                productId={item.retailerProduct.id}
                                item={item}
                                cartItems={cartItems}
                                history={history}
                                language={language}
                              />
                            </div>
                          ))}
                        </>
                      </div>
                    )}
                    contentPrefix="similarOffers"
                  />
                </div>
              </div>
              )
            )}

            {/* Frequently Bought Together */}
            {(storeId && relatedProducts && !relatedLoading)
            && (
              (relatedProducts.length > 0)
              && (
              <div className={style.similarProContainer}>
                <div className={style.headText}>Frequently Bought Together</div>

                <div className={style.scrollOuter}>
                  <CustomScroller
                    content={(
                      <div className="d-flex">
                        <>
                          {relatedProducts.map((prod:any) => (
                            <div className={style.exploreCard} key={prod.libraryProductId}>
                              <ProductThumb
                                key={prod.libraryProductId}
                                libraryProductId={prod.libraryProductId}
                                retailProductId={prod.retailerProductId}
                                name={prod.name}
                                image={prod.image}
                                mrp={prod.mrp}
                                sellingPrice={prod.sellingPrice}
                                measurementDisplayText={prod.measurementDisplayText}
                                storeId={prod.store.id}
                                offerPercent={prod.offerPercent}
                                previouslyBought={prod.previouslyBought}
                                inStock={prod.inStock}
                                cartItems={cartItems}
                                page="PRODUCT_SCREEN"
                                toggleSideOverlay={null}
                                language={language}
                                section="Frequently bought together"
                              />
                            </div>
                          ))}
                        </>
                      </div>
                    )}
                    contentPrefix="RecommendedProduct"
                  />
                </div>
              </div>
              )
            )}
          </div>
        </div>

        {product.seoText && (
          <div className={style.seoContent} dangerouslySetInnerHTML={{ __html: product.seoText }} />
        )}

        {
          (childCatSeo.childCat && !childCatSeo.childCatErr) && (
            <div className={style.blogLinkContent}>
              <h4>Discover More Products</h4>

              {childCatSeo.childCat.map((item:any) => {
                const catUrl = getSEOFriendlyURL(item.categoryCode);
                const parentCat = getSEOFriendlyURL(childCatSeo.parent.categoryCode);
                const blogUrl = `${baseUrl}/pc/${parentCat}/${catUrl}`;

                return (
                  <a href={blogUrl} className={style.blogLink} key={item.name}>{item.name}</a>
                );
              })}
            </div>
          )
        }

        {
          ((moreShops.storeCategories && !moreShops.moreShopsErr) && (
            <>
              {(moreShops.city.length > 0
            || moreShops.storeCategories.length > 0
            || moreShops.localities.length > 0) && (
              <div className={style.blogLinkContent}>
                <h4>Discover More Shops</h4>
                {
                moreShops.city.map((item:any) => (
                  <a href={item.link} className={style.blogLink} key={item.name}>
                    Stores in
                    {' '}
                    {item.name}
                  </a>

                ))
              }
                {
                 moreShops.storeCategories.map((item:any) => (
                   <a href={item.link} className={style.blogLink} key={item.name}>{item.name}</a>

                 ))
              }

                {
                moreShops.localities.map((item:any) => (
                  <a href={item.link} className={style.blogLink} key={item.name}>
                    Stores in
                    {' '}
                    {item.name}
                  </a>

                ))
              }
              </div>
              )}
            </>
          ))
        }

      </div>
      )}

      {(!isMobile && showStoreVariants) && (
      <CustomModal
        show={showStoreVariants}
        onHide={() => setProductState({
          ...productState,
          showStoreVariants: false,
        })}
        size="md"
        body={(
          <SellingStores
            productId={selectedVariant.productId}
            language={language}
            isMobile={isMobile}
            onClose={() => {
              setProductState({
                ...productState,
                showStoreVariants: false,
              });
            }}
            isProductDetailScreen
          />
        )}
      />
      )}

      <div className={`${style.footerContainer} bg-black`}>
        <div
          className="d-md-none bg-black"
        >
          <FooterMobile
            {...props}
            language={language}
          />
          <div className="p-6" />
        </div>
        <div
          className="d-none d-md-block bg-black"
        >
          <Footer
            {...props}
            language={language}
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state:any) => ({
  cartItems: state.main.cartItems,
  cartId: state.main.cartId,
});

ProductScreen.propTypes = {
  cartItems: PropTypes.shape({}),
  cartId: PropTypes.number,
  location: PropTypes.shape({
    state: PropTypes.shape({
      sid: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
      showOfferDetail: PropTypes.bool,
    }),
  }).isRequired,
};

ProductScreen.defaultProps = {
  cartItems: null,
  cartId: null,
};

export default connect(mapStateToProps)(ProductScreen);
